import { render } from "./Catalog-btn.vue?vue&type=template&id=30a0986d&scoped=true"
import script from "./Catalog-btn.vue?vue&type=script&lang=js"
export * from "./Catalog-btn.vue?vue&type=script&lang=js"

import "./Catalog-btn.vue?vue&type=style&index=0&id=30a0986d&scoped=true&lang=css"

import exportComponent from "/Volumes/DEXP W500C/homePc/актуально/new-dff/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30a0986d"]])

export default __exports__